



































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TicketEvent, PricingDetails } from '@openticket/sdk-shop';

@Component
export default class CartReviewTicket extends Vue {
    @Prop({ required: true }) ticketId!: string;

    ticket: TicketEvent | null = null;

    originalPricing: PricingDetails | null = null;

    ticketListener!: string;

    created(): void {
        this.ticketListener = this.$shop.cart.on(
            ['ticket', this.ticketId],
            (path: string[], details: TicketEvent) => {
                this.updateTicket(details);
            }
        );

        this.originalPricing = this.$shop.data.tickets_map[
            this.ticketId
        ].original_pricing;

        this.updateTicket(this.$shop.cart.getTicketInfo(this.ticketId));
    }

    updateTicket(details: TicketEvent): void {
        this.ticket = details;
    }

    destroyed(): void {
        this.$shop.off(this.ticketListener);
    }

    protected get ticketFreePriceSlug(): string | null {
        if (this.$te('shop.components.shop_group_item.ticket.item_free')) {
            return 'shop.components.shop_group_item.ticket.item_free';
        }

        return 'shop.components.shop_group_item.item_free';
    }

    protected get ticketPriceSlug(): string | null {
        if (this.$te('shop.components.shop_group_item.ticket.item_price')) {
            return 'shop.components.shop_group_item.ticket.item_price';
        }

        return 'shop.components.shop_group_item.item_price';
    }

    get ticketFeeSlug(): string | null {
        if (this.$te('shop.components.shop_group_item.ticket.item_fee')) {
            return 'shop.components.shop_group_item.ticket.item_fee';
        }

        return 'shop.components.shop_group_item.item_fee';
    }

    protected get totalPriceSlug(): string {
        if (this.$te('shop.components.shop_group_item.ticket.price_total')) {
            return 'shop.components.shop_group_item.ticket.price_total';
        }

        return 'shop.components.shop_group_item.price_total';
    }
}
